import React, { useState } from 'react';
import './LandingPageV2.css';
import { Link } from 'react-router-dom';
import girlBoyLaptopStudying from "../../assets/svg/girl_boy_laptop_studying.svg"
import logo from "../../assets/svg/school_shala_logo.svg"
import { Cuboid, Globe, LaptopMinimalCheck, Menu } from 'lucide-react';
import PythonSVG from "../../assets/svg/python_outline.svg";
import ContactForm from '../ContactForm/ContactForm';
import form, { FORM_MESSAGE } from '../../constant/form';
import validate from '../../validation/contactForm';
import { submit as contactFormSubmit } from '../../utils/contactFrom';

const LandingPage = () => {
  const [showMobNav, setShowMobNav] = useState(false);
  const [formStatus, setFormStatus] = useState(form.UNSUBMITTED);

  const handleFormSubmit = (data)=>{

    const isValid = validate(data);

    if(!isValid) {
      alert(FORM_MESSAGE.INVALID);
      setFormStatus(form.INVALID);
      return;
    }
    setFormStatus(form.LOADING);

    contactFormSubmit(data, () => {
      alert(FORM_MESSAGE.SUCCESS);
      setFormStatus(form.SUCCESS);
    });
    
  }

  return (
    <div className="landing">
      <header >
        <div className="header">

        
        <div className="logo">
          <img className="logo-img" src={logo} alt="school-shala-logo"/>
          School Shala
          </div>
        <nav className="nav">
          <a className='nav-link' href="#courses">Courses</a>
          <a className='nav-link' href="#why">Why Kids Love Us</a>
          <a className='nav-link' href="#contact">Contact</a>
          <div className="d-flex gap-3">
            <a href='#contact' className="cta-header">Demo Class</a>
            <Link to="/login" className="cta-header-outline">Login</Link>
          </div>
        </nav>
        <div className="nav-mobile">
          <button className='nav-mobile-menu-btn btn-primary' onClick={() => setShowMobNav(!showMobNav)}>
            <Menu />
          </button>
        </div>
        </div>
        <nav className="">
          <div className={"nav-mobile-menu-item "+(showMobNav && "show")} >
            <a href="#courses">Courses</a>
            <a href="#why">Why Kids Love Us</a>
            <a href="#contact">Contact</a>
            <div className="d-flex gap-3">
              <a href='#contact' className="cta-header">Demo Class</a>
              <Link to="/login" className="cta-header-outline">Login</Link>
            </div>
          </div>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-text">
          <h1>Ignite Young Minds with Coding & Computer Skills!</h1>
          <p>Fun and interactive courses for kids aged 6–14. Learn Coding, Web Development, and more.</p>
          <div className="hero-buttons">
            <a href='#courses' className="btn-primary">Explore Courses</a>
            <a className="btn-secondary" href="#contact">Try a Free Class</a>
          </div>
        </div>
        <div className="hero-img">
          {/* Optional: Add an image here */}
          <img src={girlBoyLaptopStudying} alt="" width={500}/>
        </div>
      </section>

      <section className="offerings" id="courses">
        <h2>What We Offer</h2>
        <div className="cards">
          <div className="card">
            <LaptopMinimalCheck size={48} />
            <h3>Computer Fundamentals</h3>
            <p>Typing skills, digital safety, file management.</p>
          </div>
          <div className="card">
            <Cuboid size={48} />
            <h3>Block-Based Coding</h3>
            <p>Visual programming using Scratch & Code.org.</p>
          </div>
          {/* <div className="card">
            <img src={PythonSVG} alt="Python" width={48} />
            <h3>Python for Kids</h3>
            <p>Learn Python through fun projects & logic games.</p>
          </div> */}
          <div className="card">
            <Globe size={48}/>
            <h3>Web Development</h3>
            <p>Build real websites using HTML, CSS, and JS.</p>
          </div>
        </div>
      </section>

      <section className="why" id="why">
        <h2>Why Kids Love Us</h2>
        <ul className="why-list">
          <li><span>🎮</span> Game-Based Learning</li>
          <li><span>🏆</span> Certifications & Achievements</li>
          <li><span>👨‍🏫</span> Expert Instructors</li>
          <li><span>🕹️</span> Interactive Projects</li>
          <li><span>👨‍👩‍👧</span> Parental Dashboard</li>
        </ul>
        {/* <div className="testimonial">
          <p>“My son built his own game in just 4 weeks!”</p>
          <span>– Ria, parent</span>
        </div> */}
      </section>

{/* 
      <section className="batches">
        <h2>Upcoming Batches</h2>
        <ul>
          <li>Python Level 1 – Starts April 20</li>
          <li>Scratch Beginners – Starts April 25</li>
          <li>Website Builders Club – Starts May 1</li>
        </ul>
        <div className="demo-cta">
          <h3>Still Unsure?</h3>
          <p>Book a Free Demo Class</p>
          <button className="btn-primary">Book Demo</button>
          <button className="btn-secondary">Chat with Us</button>
        </div>
      </section> */}

      <div id="contact" >
        <ContactForm handleSubmit={handleFormSubmit} setFormStatus={setFormStatus} formStatus={formStatus} />
      </div>

      <footer className="footer">
        <p>&copy; 2025 School Shala. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
